import {Course} from "./course.model";

export interface CourseCategory {
  id?: number;
  name: string;
  description: string;
  courses?: Course[];
  created_at?: Date;
  edited_at?: Date;
  category_id?: number; // fk
  selected?: boolean;
}

export type NavBarItemType = {
  id: number;
  label: string;
  url: string;
  selected: boolean;
}
export type NavBarItemTypes = NavBarItemType []

export const navbarGroup: NavBarItemTypes = [
  {
    id: 1,
    label: "Kursliste",
    url: "/courses",
    selected: true,
  },
  {
    id: 2,
    label: "Projektliste",
    url: "/projects/list",
    selected: false,
  },
  {
    id: 3,
    label: "Demokratiewerkstatt",
    url: "/demokratiewerkstatt/list",
    selected: false,
  },
  {
    id: 4,
    label: "Liste der Kurskategorien",
    url: "/course-category/list",
    selected: false,
  },
]
